import { createSlice } from "@reduxjs/toolkit";
import { createAiCampaignAPI } from "../../services/createAiCampaign";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const createAiCampaignSlice = createSlice({
  name: "createAiCampaign",
  initialState: data,
  reducers: {
    createAiCampaignInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    createAiCampaignInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Campaign created successfully";
      state.error = "";
    },
    createAiCampaignInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      const p = action.payload;
      state.error =
        typeof p === "string"
          ? p
          : p?.message != null
            ? String(p.message)
            : Array.isArray(p?.errors)
              ? p.errors.map(String).join(" ")
              : p != null
                ? String(p)
                : "Something went wrong";
      state.data = null;
    },
    createAiCampaignInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const createAiCampaignHandler = (payload) => async (dispatch) => {
  try {
    dispatch(createAiCampaignAction.createAiCampaignInfo());
	  const response = await createAiCampaignAPI(payload);
	  
    dispatch(createAiCampaignAction.createAiCampaignInfoSuccess(response));
  } catch (e) {
    const raw =
      typeof e === "string"
        ? e
        : e?.response?.data?.message ?? e?.message ?? e;
    dispatch(createAiCampaignAction.createAiCampaignInfoFailure(raw));
  }
};

export default createAiCampaignSlice.reducer;
export const createAiCampaignAction = createAiCampaignSlice.actions;
